export const typeDefs = `
  CitizenReferralCommissionsHistorySortType
  = date
  | platformName
  | merchantReferralCommission
  | citizenReferralCommission
  | totalCommission

  CitizenReferralCommissionsHistoryFilterInput {
    date: [String]
    platformName: String,
    merchantReferralCommission: [Float]
    citizenReferralCommission: [Float]
    totalCommission: [Float]
  }

  SuperOrderPassiveIncomeSortType
  = date
  | vaultCapacity
  | sopIncome
  | netIncome
  | vaultExcess
  | lockedEarnings

  SuperOrderPassiveFilerInput {
    date: [String]
    vaultCapacity: [Float]
    sopIncome: [Float]
    netIncome: [Float]
    vaultExcess: [Float]
    lockedEarnings: [Float]
  }
`;
